import * as React from 'react';
import {observer} from 'mobx-react';
import * as classnames from 'classnames/bind';
import {Dialogs} from '@mintdata-wsp/wsp/controllers/common/DialogsController';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Form} from '@mintdata-wsp/wsp/ui/components/forms/data/Form';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {InputField} from '@mintdata-wsp/wsp/ui/components/forms/InputField';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {TextHeading} from '@mintdata-wsp/wsp/ui/components/general/TextHeading';
import {WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';
import {FlowExecType} from '@mintdata-wsp/common/controllers/flow/FlowController';

const styles = require('./FlowRunWithParametersDialog.less');
const cx = classnames.bind(styles);

@observer
export class FlowRunWithParametersDialog extends React.Component<any, any>
{
    private _form:Form = new Form();

    private _getRunHandler = (execType:FlowExecType):() => void =>
    {
        return () =>
        {
            const {ui} = controllers;
            const {dialogs, flow} = ui;

            const openFlow = flow.getOpenFlow();

            if( this._form.areAllFieldsValid() )
            {
                const formFields = this._form.getFields();
                const inputValues = new Map(Object.entries(formFields).map(([k, v]) => [k, v.value]) as any);

                flow.setFlowLastInputValues(openFlow.id, inputValues as Map<string, string>);
                flow.execFlowFromEditor(openFlow, inputValues as Map<string, string>, execType);

                dialogs.hideDialog(Dialogs.FlowRunWithParameters);
            }
        };
    };

    private _renderFields():JSX.Element[]
    {
        const {flow} = controllers.ui;

        const openFlow = flow.getOpenFlow();

        return openFlow.orderedInputNames.map((name:string, index:number) => (
            <div key={name} className={cx('inputField')}>
                <InputField
                    label={name}
                    isInitiallyFocused={index === 0}
                    isInitiallySelected={index === 0}
                    initialValue={openFlow.lastInputValues.get(name)}
                    formKey={name}
                    form={this._form}
                />
            </div>
        ));
    }

    render()
    {
        return (
            <Dialog>
                <div className={cx('base')}>
                    <Row>
                        <Column className={cx('contentColumn')}>
                            <TextHeading className={cx('textHeading')}>Run with parameters</TextHeading>

                            {this._renderFields()}

                            <Row className={cx('actionRow')}>
                                <WSPButton
                                    className={cx('actionButton')}
                                    caption={'Run'}
                                    onClick={this._getRunHandler(FlowExecType.REST)}
                                />
                                <WSPButton
                                    className={cx('actionButton')}
                                    caption={'Run Streaming'}
                                    onClick={this._getRunHandler(FlowExecType.Stream)}
                                />
                            </Row>
                        </Column>
                    </Row>
                </div>
            </Dialog>
        );
    }
}
